import React, { useContext, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { defaultDateTimeFormat } from "../../lib/utils";
import { PromoCodesContext } from "./PromoCodes";

interface Filters {
    showArchived: boolean;
}

const PromoCodesTable = (): React.JSX.Element => {
    const { promoCodes, setPromoCodes } = useContext(PromoCodesContext);

    const [filters, setFilters] = useState<Filters>({
        showArchived: false,
    });

    return (
        <>
            <Button
                className="mt-4"
                onClick={() =>
                    setFilters(prev => {
                        return { ...prev, showArchived: !prev.showArchived };
                    })
                }
            >
                {filters.showArchived ? `Hide` : `Show`} Archived Promo Codes
            </Button>
            <Table className="promoCodesTable" striped bordered>
                <thead>
                    <tr>
                        <th>Promo Code</th>
                        <th>Description</th>
                        <th>Discount</th>
                        <th>Type</th>
                        <th>Uses</th>
                        <th>Active</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Edit</th>
                    </tr>
                </thead>
                <tbody>
                    {promoCodes
                        .filter(p => {
                            return filters.showArchived
                                ? true
                                : p.active !== -1;
                        })
                        .map(p => (
                            <tr key={p.id}>
                                <td
                                    className={`${p.active === -1 ? `bg-danger-subtle` : ""}`}
                                >
                                    {p.code}
                                </td>
                                <td
                                    className={`${p.active === -1 ? `bg-danger-subtle` : ""}`}
                                >
                                    {p.description}
                                </td>
                                <td
                                    className={`${p.active === -1 ? `bg-danger-subtle` : ""}`}
                                >
                                    {p.promoCodeType.category === "fixed"
                                        ? "$"
                                        : ""}
                                    {p.discount}
                                    {p.promoCodeType.category === "percent"
                                        ? "%"
                                        : ""}
                                </td>
                                <td
                                    className={`${p.active === -1 ? `bg-danger-subtle` : ""}`}
                                >
                                    {p.promoCodeType.name}
                                </td>
                                <td
                                    className={`${p.active === -1 ? `bg-danger-subtle` : ""}`}
                                >
                                    {p.maxUses !== null
                                        ? `${p.usedCount} / ${p.maxUses}`
                                        : p.usedCount}
                                </td>
                                <td
                                    className={`${p.active === -1 ? `bg-danger-subtle` : ""}`}
                                >
                                    {p.active === -1
                                        ? "Archived"
                                        : p.active === 1 &&
                                            (p.startDate
                                                ? new Date() >
                                                  new Date(p.startDate)
                                                : true) &&
                                            (p.endDate
                                                ? new Date() <
                                                  new Date(p.endDate)
                                                : true)
                                          ? "Yes"
                                          : "No"}
                                </td>
                                <td
                                    className={`${p.active === -1 ? `bg-danger-subtle` : ""}`}
                                >
                                    {p.startDate &&
                                        `${
                                            defaultDateTimeFormat
                                                .format(new Date(p.startDate))
                                                .split(", ")[0]
                                        }`}
                                    <br />
                                    {p.startDate &&
                                        `${
                                            defaultDateTimeFormat
                                                .format(new Date(p.startDate))
                                                .split(", ")[1]
                                        }`}
                                </td>
                                <td
                                    className={`${p.active === -1 ? `bg-danger-subtle` : ""}`}
                                >
                                    {p.endDate &&
                                        `${
                                            defaultDateTimeFormat
                                                .format(new Date(p.endDate))
                                                .split(", ")[0]
                                        }`}
                                    <br />
                                    {p.endDate &&
                                        `${
                                            defaultDateTimeFormat
                                                .format(new Date(p.endDate))
                                                .split(", ")[1]
                                        }`}
                                </td>
                                <td
                                    className={`${p.active === -1 ? `bg-danger-subtle` : ""}`}
                                >
                                    <Link
                                        to={`/tournament-management/promo-codes/edit/${p.id}`}
                                    >
                                        edit
                                    </Link>
                                </td>
                            </tr>
                        ))}
                </tbody>
            </Table>
        </>
    );
};

export default PromoCodesTable;
